'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Enemy = function (_Phaser$Sprite) {
  _inherits(Enemy, _Phaser$Sprite);

  function Enemy(game, x, y, image, gravity) {
    _classCallCheck(this, Enemy);

    var _this = _possibleConstructorReturn(this, (Enemy.__proto__ || Object.getPrototypeOf(Enemy)).call(this, game, x, y, image));

    _this.anchor.set(0.5);
    _this.game.physics.enable(_this);
    _this.body.collideWorldBounds = true;
    _this.body.allowGravity = gravity;
    _this.body.velocity.x = 100;
    // animations
    _this.animations.add('move', [0, 1, 2], 8, true);
    _this.animations.add('die', [3, 3], 6);
    _this.animations.play('move');
    return _this;
  }

  _createClass(Enemy, [{
    key: 'update',
    value: function update() {
      // check against walls and reverse direction if necessary
      if (this.body.touching.right || this.body.blocked.right) {
        this.body.velocity.x = -100; // turn left
        this.scale.x = -1;
      } else if (this.body.touching.left || this.body.blocked.left) {
        this.body.velocity.x = 100; // turn right
        this.scale.x = 1;
      }
    }
  }, {
    key: 'die',
    value: function die() {
      var _this2 = this;

      this.body.enable = false;
      this.animations.play('die').onComplete.addOnce(function () {
        return _this2.kill();
      });
    }
  }]);

  return Enemy;
}(_phaser2.default.Sprite);

exports.default = Enemy;


//////////////////
// WEBPACK FOOTER
// ./src/sprites/Enemy.js
// module id = 341
// module chunks = 0